var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F9FAFB",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_517_8265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3335 26.3352L23.0002 23.0019M23.0002 23.0019L19.6669 26.3352M23.0002 23.0019V30.5019M29.9919 28.3269C30.8047 27.8838 31.4467 27.1826 31.8168 26.334C32.1868 25.4855 32.2637 24.5379 32.0354 23.6408C31.807 22.7436 31.2865 21.9481 30.5558 21.3797C29.8251 20.8113 28.9259 20.5025 28.0002 20.5019H26.9502C26.698 19.5262 26.2278 18.6205 25.5752 17.8527C24.9225 17.0849 24.1042 16.4751 23.182 16.069C22.2597 15.663 21.2573 15.4713 20.2503 15.5084C19.2433 15.5455 18.2578 15.8104 17.3679 16.2832C16.4779 16.7561 15.7068 17.4244 15.1124 18.2382C14.518 19.0519 14.1158 19.9898 13.936 20.9814C13.7563 21.9729 13.8036 22.9923 14.0746 23.9629C14.3455 24.9335 14.8329 25.8301 15.5002 26.5852",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_517_8265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.7040a91985c637e48b64ade831086e57.svg";
export { ForwardRef as ReactComponent };